export default __webpack_public_path__ + "static/media/CNo.59-1.c312f3e6.jpg";